export enum VatPrefixEnum {
  Andorra = 'AD',
  Argentina = 'AR',
  Austria = 'AT',
  Belgium = 'BE',
  Bulgaria = 'BG',
  Cyprus = 'CY',
  CzechRepublic = 'CZ',
  Croatia = 'HR',
  Denmark = 'DK',
  Estonia = 'EE',
  Finland = 'FI',
  France = 'FR',
  Germany = 'DE',
  GreatBritain = 'GB',
  Greece = 'EL',
  Hungary = 'HU',
  Ireland = 'IE',
  Italy = 'IT',
  Latvia = 'LV',
  Lithuania = 'LT',
  Luxembourg = 'LU',
  Maldive = 'MV',
  Malta = 'MT',
  Marocco = 'MA',
  Netherlands = 'NL',
  Poland = 'PL',
  Portugal = 'PT',
  Romania = 'RO',
  SanMarino = 'SM',
  Serbia = 'RS',
  Slovakia = 'SK',
  Slovenia = 'SI',
  Spain = 'ES',
  Sweden = 'SE',
  Swiss = 'CHE',
  NewZealand = 'NZ',
  NorthernIreland = 'XI',
  NoPrefix = ''
}
